import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';

function Contact() {
  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contactez-moi</h1>
          <p>Pour toute question sur l'infrastructure ou le déploiement du projet Technova SISRH.</p>
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { m: 1, width: '100%' },
            }}
            noValidate
            autoComplete="off"
          >
            <div className='form-flex'>
              <TextField
                required
                id="outlined-required"
                label="Votre Nom"
                placeholder="Comment vous appelez-vous ?"
              />
              <TextField
                required
                id="outlined-required"
                label="Email / Téléphone"
                placeholder="Comment puis-je vous joindre ?"
              />
            </div>
            <TextField
              required
              id="outlined-multiline-static"
              label="Message"
              placeholder="Envoyez-moi un message"
              multiline
              rows={10}
              className="body-form"
            />
          </Box>
          <div className="contact-info" style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <p><strong>Nom:</strong> MBE Alain Martial</p>
            <p><strong>Téléphone:</strong> +32 466 36 86 34</p>
            <p><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/martialmbe/" target="_blank" rel="noreferrer" style={{color: '#5000ca'}}>linkedin.com/in/martialmbe</a></p>
            <p><strong>GitHub:</strong> <a href="https://github.com/amartial" target="_blank" rel="noreferrer" style={{color: '#5000ca'}}>github.com/amartial</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
